import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-login_arrow",
  "use": "icon-login_arrow-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-login_arrow\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h44v44H0z\" /><path fill=\"#999\" d=\"m24.149 22-9.075-9.075 2.592-2.592L29.333 22 17.666 33.667l-2.592-2.592z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol